import { HttpService } from "../http/HttpService";
import { AbstractAdminEntityService } from "./AbstractAdminEntityService";
import { CashbackPayoutListResponse, CashbackPayoutPerCurrencyRow } from "../http/protocol";

export class CashbackPayoutService extends AbstractAdminEntityService<CashbackPayoutPerCurrencyRow, CashbackPayoutListResponse> {
  constructor(http: HttpService) {
    super("/cashback/payout", http);
  }
}
